import React, { useEffect, useState } from "react";
import AdminAppBody from "../../../../components/admin/AdminAppBody";
import { apiRoutes } from "../../../../routes/api/apiRoutes";
import useApiCallHooks from "../../../../hooks/useApiCallHooks";
import PageHeading from "../../../../components/admin/common/PageHeading";

const MentorRequestList = () => {
  const [responce, loading, error, callAPI, statusCode] = useApiCallHooks();
  const [showModal, setShowModal] = useState(false);
  const [selectedMentor, setSelectedMentor] = useState(null);
  const [selectedReason, setSelectedReason] = useState("");
  const [customReason, setCustomReason] = useState("");

  const [requests, setRequests] = useState([]);

  

  useEffect(() => {
    
    callAPI("get", apiRoutes.admin.mentorRequestList, "");
  }, []);
  
  

  if (
    Array.isArray(responce?.data) &&
    responce.data.length > 0 &&
    requests.length === 0 &&
    statusCode === 200
  ) {
    setRequests(responce.data);
  }

  const handleStatusUpdate = (id, status) => {
    callAPI("post", apiRoutes.admin.mentorRequestApproved, {
      id: id,
      status: status,
    });
  };

  const reasons = [
    "Incomplete profile",
    "Lack of experience",
    "Not available",
    "Other",
  ];

  const handleRejectClick = (mentor) => {
    setSelectedMentor(mentor);
    setShowModal(true);
    setSelectedReason("");
    setCustomReason("");
  };

  const handleRejectSubmit = () => {
    const reasonToUse = customReason.trim() || selectedReason;
    if (!reasonToUse) {
      alert("Please select or enter a reason");
      return;
    }
    const updated = requests.map((req) =>
      req.id === selectedMentor.id
        ? { ...req, status: `Rejected - ${reasonToUse}` }
        : req
    );

    setRequests(updated);
    setShowModal(false);
    setSelectedMentor(null);
    setSelectedReason("");
    setCustomReason("");
  };

  // Close modal on background click or cancel
  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedMentor(null);
    setSelectedReason("");
    setCustomReason("");
  };

  return (
    <AdminAppBody
      content={
        <div className="container">
          <PageHeading
            title="User List"
            subTitle="Manage all registered users with their roles and statuses."
          />
          <div className="sys-list-table card shadow-sm rounded-lg mt-4 overflow-hidden">
            <div className="table-responsive">
              <table className="table table-hover align-middle sys-list-table__content">
                <thead className="table-light">
                  <tr>
                    <th> Name</th>
                    <th>Email</th>
                    <th>Mobile No</th>
                    <th>Experience</th>
                    <th>Skills</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {requests.map((mentor) => (
                    <tr key={mentor.id}>
                      <td>{mentor.first_name + " " + mentor.last_name}</td>
                      <td>{mentor.email}</td>
                      <td>{mentor.mobile_no}</td>
                      <td>{mentor.experiance}</td>
                      <td>{mentor.skills}</td>
                      <td>{mentor.status}</td>
                      <td>
                        {mentor.status === 0 && (
                          <>
                            <button
                              className="btn  me-2"
                              onClick={() => handleStatusUpdate(mentor.id, 1)}
                            >
                              Accept
                            </button>
                            <button
                              className="btn "
                              onClick={() => handleStatusUpdate(mentor.id, 2)}
                            >
                              Reject
                            </button>
                          </>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Search & Filter Section */}
        </div>
      }
    />
  );
};

export default MentorRequestList;
